import cn from 'classnames'
import React, { ComponentProps } from 'react'

type FileXIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function FileXIcon(props: FileXIconProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('FileXIcon', className)}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <rect x="0.5" width="24" height="24" rx="4" fill="#EBF2FE" />
      <path
        d="M13.8334 5.33325V7.99992C13.8334 8.35354 13.9738 8.69268 14.2239 8.94273C14.4739 9.19278 14.8131 9.33325 15.1667 9.33325H17.8334M14.1667 12.3333L10.8334 15.6666M10.8334 12.3333L14.1667 15.6666M14.5 5.33325H8.50002C8.1464 5.33325 7.80726 5.47373 7.55721 5.72378C7.30716 5.97382 7.16669 6.31296 7.16669 6.66659V17.3333C7.16669 17.6869 7.30716 18.026 7.55721 18.2761C7.80726 18.5261 8.1464 18.6666 8.50002 18.6666H16.5C16.8536 18.6666 17.1928 18.5261 17.4428 18.2761C17.6929 18.026 17.8334 17.6869 17.8334 17.3333V8.66659L14.5 5.33325Z"
        stroke="#4489F9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
